<template>
  <a-layout class="main-layout">
    <s-header></s-header>
    <div class="contenter">
      <a-layout-header>
        <div class="logo" />
      </a-layout-header>
      <div class="content">
        <a-layout class="content-layout">
          <a-layout-sider
            width="200"
            style="background: #fff"
            class="sider-layout"
          >
            <div class="avatar">
              <img
                :src="AccountInfo.avatar||require('@/assets/img/avatar.png')"
                style="width: 80px;height: 80px;border-radius: 50%;margin-bottom:5px"
                alt=""
              >
              <span>{{AccountInfo.nickname}}</span>
            </div>
            <a-menu
              class="leftmenu"
              mode="inline"
              :defaultSelectedKeys="[$route.meta.menu]"
              style="border-right-width: 0px;"
            >
              <a-menu-item
                v-for="v in menu"
                :key="v.name"
                
              >
                <router-link
                  :to="{name: v.name}"
                  :class="[`icon-${v.name}`]"
                >
                  {{v.title}}
                </router-link>
              </a-menu-item>
            </a-menu>
            <!-- <div class="footer">
              <p>Copyright © 2020</p>
              <p>闽ICP备18003679号-2</p>
            </div> -->
          </a-layout-sider>
          <a-layout style="background:#fff">
            <s-router-layout></s-router-layout>
          </a-layout>
        </a-layout>
      </div>
    </div>
    <s-footer></s-footer>
  </a-layout>
</template>
<script>
import RouterLayout from "./RouterLayout";
import Header from "./Header";
import Footer from "./Footer";
import { mapGetters } from "vuex";
export default {
  components: {
    "s-router-layout": RouterLayout,
    "s-header": Header,
    "s-footer": Footer
  },
  data() {
    return {
      AccountInfo: {},
      menu: [
        { title: "我的账户", name: "dashboard" },
        // { title: "我的关键人", name: "keyperson" },
        { title: "我的展会名录", name: "exhibitor" },
        { title: "我的采购商",name: "buyer"},
        { title: "查询记录", name: "findlog" },
        { title: "个人信息", name: "profile" },
        { title: "账号绑定", name: "related" }
      ]
    };
  },
  methods: {
    ...mapGetters(["GetAccountInfo"])
  },
  mounted() {
    this.AccountInfo = this.GetAccountInfo();
    // 验证登录
    // this.$http.post("/accountInfo");
  }
};
</script>
<style lang="scss">
.content-layout {
  .sider-layout {
    .ant-layout-sider-children {
      display: flex;
      flex-flow: column;
      .leftmenu {
        flex: 1;
      }
      .footer {
        font-size: 12px;
        color: #c3c3c3;
        text-align: center;
        p {
          margin-bottom: 5px;
        }
        margin-bottom: 10px;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
@import "./style/mixin.scss";
.ant-layout-sider {
  border-right: 1px solid #e9eef2;
  border-left: 1px solid #e9eef2;
}
.contenter {
  .content {
    width: 1200px;
    margin: 0 auto;
  }
}
.ant-layout-header {
  padding: 0;
  height: 75px;
  background-color: #e9eef2;
  .logo {
    display: inline-block;
    width: 1200px;
    margin: 0 auto;
    height: 100%;
    background: url("~@/assets/img/logo.png") no-repeat;
  }
}
.avatar {
  width: 200px;
  height: 200px;
  text-align: center;
  font-size: 12px;
  color: #999;
  img {
    margin: auto;
    margin-top: 50px;
    display: inherit;
  }
}

.icon {
  width: 24px;
  height: 24px;
  display: inline-block;
}

.icon-dashboard {
  margin-left: 30px;
  &.router-link-active::before {
    @include menu-icon;
    background-position: -22px 0 !important;
  }
  &::before {
    @include menu-icon;
    background-position: 0 0;
  }
}

.icon-related {
  margin-left: 30px;
  &.router-link-active::before {
    @include menu-icon;
    background-position: -22px -142px !important;
  }
  &::before {
    @include menu-icon;
    background-position: 0 -142px;
  }
}
.icon-notify {
  margin-left: 30px;
  &.router-link-active::before {
    @include menu-icon;
    background-position: -22px -122px !important;
  }
  &::before {
    @include menu-icon;
    background-position: 0 -122px;
  }
}
.icon-exhibitor {
  margin-left: 30px;
  &.router-link-active::before {
    @include menu-icon;
    background-position: -22px -22px !important;
  }
  &::before {
    @include menu-icon;
    background-position: 0 -22px;
  }
}
.icon-buyer {
  margin-left: 30px;
  &.router-link-active::before {
    @include menu-icon;
    background-position: -22px -42px !important;
  }
  &::before {
    @include menu-icon;
    background-position: 0 -42px;
  }
}
.icon-findlog {
  margin-left: 30px;
  &.router-link-active::before {
    @include menu-icon;
    background-position: -22px -62px !important;
  }
  &::before {
    @include menu-icon;
    background-position: 0 -62px;
  }
}
.icon-profile {
  margin-left: 30px;
  &.router-link-active::before {
    @include menu-icon;
    background-position: -22px -82px !important;
  }
  &::before {
    @include menu-icon;
    background-position: 0 -82px;
  }
}
.ant-menu-item {
  line-height: 60px;
  height: 60px;
  border-bottom: 1px solid #e9eef2;
  margin: 0 !important;
  color: #6bafe1;
}
.ant-menu-item:first-child {
  border-top: 1px solid #e9eef2;
}
.ant-menu-item-selected,
.ant-menu-item-selected > a,
.ant-menu-item-selected > a:hover {
  background-color: #f4faf9 !important;
  color: #05926d !important;
}
</style>
